<template>
    <div>
        <PageHeader :title="title" />

        <div class="row" v-if="efpData">
            <div class="col-lg-4 d-flex">
                <div class="card w-100">
                    <div class="card-body d-flex flex-column">
                        <h3 class="card-title mb-4">Taux d'avancement par EFP</h3>
                        <List :items="efpData.list" />
                    </div>
                </div>
            </div>
            <div class="col-lg-8 d-flex">
                <div class="card w-100">
                    <div class="card-body">
                        <div class="row">
                            <div class="col">
                                <h4 class="card-title mb-4">Avancement par EFP</h4>
                            </div>
                            <div class="col-3">
                                <dropdown placeholder="Année scolaire" v-model="selectedYear" :options="yearsList" />
                            </div>
                        </div>
                        <Chart ref="efpChart" :items="efpData.chart" />
                    </div>
                </div>
            </div>
        </div>

        <div class="row" v-if="complexesData">
            <div class="col-lg-4 d-flex">
                <div class="card w-100">
                    <div class="card-body d-flex flex-column">
                        <h3 class="card-title mb-4">Taux d'avancement par complexe</h3>
                        <List :items="complexesData.list" />
                    </div>
                </div>
            </div>
            <div class="col-lg-8 d-flex">
                <div class="card w-100">
                    <div class="card-body">
                        <div class="row">
                            <div class="col">
                                <h4 class="card-title mb-4">Avancement par complexe</h4>
                            </div>
                            <div class="col-3">
                                <dropdown placeholder="Année scolaire" v-model="selectedYear" :options="yearsList" />
                            </div>
                        </div>

                        <Chart ref="complexesChart" :items="complexesData.chart" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import List from "./components/list";
import Chart from "./components/chart";

export default {
    page: {
        title: "Statistiques",
        meta: [{ name: "description", content: appConfig.description }]
    },
    components: {
        PageHeader,
        List,
        Chart
    },
    data: () => ({
        title: "Statistiques",
        fields: [
            { key: "nbLaureats", label: "Nb Lauréats" },
            { key: "nbQuest", label: "Nb Enquêtes" },
            { key: "reste", label: "Reste" },
            { key: "taux", label: "Taux d'enquête" },
        ],
        data: {
            complexes: []
        },
        efp: {
            id: localStorage.getItem("selected-efp"),
            type: localStorage.getItem("selected-efp-type")
        },
        efpData: null,
        complexesData: null,
        yearsList: [],
        selectedYear: null,
        loading: false,
    }),
    methods: {
        getFields(title) {
            return [
                { key: "name", label: title },
                { key: "nbLaureats", label: "Nb Lauréats" },
                { key: "nbQuest", label: "Nb Enquêtes" },
                { key: "reste", label: "Reste" },
                { key: "taux", label: "Taux d'enquête" },
            ]
        },
        onEFPChanged(id) {
            this.efp = { id, type: localStorage.getItem("selected-efp-type") };
        },
    },
    watch: {
        selectedYear(annee) {
            this.$axios.get("/statistics", { params: { idAnnee: annee?.id } }).then(resp => {
                this.efpData = resp.efp;
                this.complexesData = resp.complexes;
            });
        },
        efpData(data) {
            this.$refs.efpChart?.$refs?.chart?.updateSeries(data.chart.series);
            this.$refs.efpChart?.$refs?.chart?.updateOptions({
                plotOptions: {
                    bar: {
                        ...(data.chart.labels.length <= 3 ? { columnWidth: "100px" } : {}),
                    },
                },
                xaxis: {
                    categories: data.chart.labels,
                },
            });
        },
        complexesData(data) {
            this.$refs.complexesChart?.$refs?.chart?.updateSeries(data.chart.series);
            this.$refs.complexesChart?.$refs?.chart?.updateOptions({
                plotOptions: {
                    bar: {
                        ...(data.chart.labels.length <= 3 ? { columnWidth: "100px" } : {}),
                    },
                },
                xaxis: {
                    categories: data.chart.labels,
                },
            });
        },
    },
    mounted() {
        this.mitt.on("efp-changed", this.onEFPChanged);

        this.$axios.get("/years").then(resp => {
            this.yearsList = resp;
            this.selectedYear = resp[0];
        });
    },
    beforeDestroy() {
        this.mitt.off("efp-changed", this.onEFPChanged);
    },
};
</script>

<style>
#sidebar-right___title__ {
    font-size: 18px;
}

.custom-radio,
.custom-checkbox {
    margin-bottom: 4px;
}
</style>
